    var url = location.href;
    if (url == "https://tsuchiya-randoseru.jp/") {
        var topanime = $.cookie("top_animation"); // cookieを取得
        if (topanime) { // 2回以上訪問時
                $('#tr_splash_bg').css('display', 'none');
                $('#tr_splash_loading').delay(200).fadeOut(500);
        } else { // 初回訪問時
            $('#tr_splash_bg').addClass('tr_js-active');
            $('#tr_splash_loading').css('display', 'block');
            $(window).on('load', function () { // ページ全体が読み込まれた時のに実行
                $('#tr_splash_bg').delay(1000).fadeOut(1000);// ローディングを隠す
                $('#tr_splash_loading').delay(900).fadeOut(800);
            });
            // スクロール、クリック時、即フェードアウト
            $(document).on('click', '#tr_splash_bg', '#tr_splash_loading', function () {
                $(this).fadeOut(2000);
            });
            $(window).on('scroll', function () {
                $('#tr_splash_bg').fadeOut(2000);
                $('#tr_splash_loading').fadeOut(2000);
            });
            $.cookie("top_animation", 1, { expires: 1 });
        }
    } else {
        $('#tr_splash_bg').css('display', 'none');
        $('#tr_splash_loading').delay(200).fadeOut(500);
    }
